<template>
  <body>
    <ModalAutores :autores="autores" v-show="modalAutores"
      @cerrar="cerrarModal"
      @recargar="recargarAutores"
      @AddAutor="otroAutor"
    />
    <aside class="Blk-1">
      <img class="imgRecorte" :src="colVista.recorteImg">
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <div class="Blk-Campo">
          <p id="titReg">Títulos registrados</p>
          <select name="titHemero" id="" class="campo"
            :disabled = 'habBotAndCamp.hab'
            v-model="hemeroSel" @change.prevent="mostrarDatosHemero(hemeroSel._id)">
            <option v-for="hemero in listaHemeros"
              :key="hemero._id"
              :value="hemero">
              {{hemero.titulo}}
            </option>
          </select>
        </div>
        <form @change="cambioForm">
          <div class="Blk-Campo">
            <p>Título completo*</p>
            <textarea name="titulo" class="campo" ref="nombreHemero" rows="2"
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="colVista.titulo"
              spellcheck="false">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Autor(es)</p>
            <div class="campo" @change="cambioAutores" >{{autoresVista}}</div>
            <div class="botonesAut">
              <button class="botAut" @click.prevent="addAutor" :disabled = '!habBotAndCamp.hab'>+</button>
              <button class="botAut" @click.prevent="delAutor" :disabled = '!habBotAndCamp.hab'> - </button>
            </div>
          </div>
          <div class="Blk-Campo">
            <p>Nombre publicación</p>
            <input type="text" name="publicacion" class="campo"
              v-model.trim="colVista.publicacion"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p># Edición</p>
            <input type="text" name="edicion" class="campo"
              v-model.trim="colVista.edicion"
              :disabled = '!habBotAndCamp.hab'>
            <p>Página</p>
            <input type="text" name="pagina" class="campo"
              v-model.trim="colVista.pagina"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Ciudad</p>
            <input type="text" name="ciudad" class="campo"
              v-model.trim="colVista.ciudad"
              :disabled = '!habBotAndCamp.hab'>
            <p>País</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="colVista.pais"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Fecha</p>
            <input type="text" name="fecha" class="campo"
              v-model.trim="colVista.fecha"
              :disabled = '!habBotAndCamp.hab'>
            <p>Idioma</p>
            <input type="text" name="idioma" class="campo" list="idiomas" autocomplete="off"
              v-model.trim="colVista.idioma"
              :disabled = '!habBotAndCamp.hab'>
            <datalist id="idiomas">
              <option value="Español">Español</option>
              <option value="Francés">Francés</option>
              <option value="Italiano">Italiano</option>
              <option value="Inglés">Inglés</option>
              <option value="Japonés">Japonés</option>
              <option value="Portugués">Portugués</option>
            </datalist>
          </div>
          <div class="Blk-Campo">
            <p>Palabras clave</p>
            <textarea name="palabrasClave" class="campo" rows="2" id=""
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="colVista.palsClave">
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>url</p>
            <input type="text" name="url" class="campo"
              v-model.trim="colVista.url"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <div class="check">
              <p>Formato papel</p>
              <input type="checkbox" name="fPapel"
                v-model.trim="colVista.papel"
                :disabled = '!habBotAndCamp.hab'>
            </div>
            <div class="check">
              <p>Formato electrónico</p>
              <input type="checkbox" name="fElec"
                v-model.trim="colVista.digital"
                :disabled = '!habBotAndCamp.hab'>
            </div>
            <div class="check">
              <p>Información reservada</p>
              <input type="checkbox" name="privado"
                :disabled = '!habBotAndCamp.hab'
                v-model.trim="colVista.reservado">
            </div>
          </div>
          <div class="BtnImg">
            <input type="file" name="file-1" id="file-1" class="inputfile" @change="cargarPortada"/>
            <label for="file-1" ><span class="icon-icoSubirImg"></span></label>
            <p id="eti">Cargar recorte</p>
          </div>
          <img class="imgRecorte2" :src="colVista.recorteImg">
        </form>
      </article>
      <aside class="Btns">
        <BotonesCRUD
        :desacMas="!habBotAndCamp.actMas"
        :desacEdit="!habBotAndCamp.actEdi"
        :desacMenos="!habBotAndCamp.actMen"
        :desacSave="!habBotAndCamp.actSav"
        @nuevo="nuevo"
        @editar="editar"
        @del="borrar"
        @save="save"
        />
      </aside>
    </aside>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import BotonesCRUD from '../components/BotonesCRUD.vue'
import ModalAutores from '../components/ModalAutores.vue'
import axios from 'axios'
export default {
  name: 'FormHemero',
  components: { BotonesCRUD, ModalAutores },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.getListaHemeros() // Trae lista de nombres de hemerografías sin otros datos
    this.getAutores()
    this.activaModo('INI')
  },
  data () {
    return {
      modalAutores: false,
      hemeroSel: [],
      hemeroSelBkUp: [],
      listaHemeros: [],
      colVista: {
        titulo: ''
      },
      colVistaBkUp: {},
      autores: [],
      autoresHemero: [],
      autoresHemeroBkUp: [],
      habBotAndCamp: {
        actMas: false,
        actEdi: false,
        actMen: false,
        actSav: false,
        hab: false
      },
      IsModoSalirMas: false,
      IsModoSalirEdi: false,
      URLbase: '',
      token: ''
    }
  },
  methods: {
    async getListaHemeros () {
      try {
        const url = `${this.URLbase}/hemerografias/listaHemeros`
        const res = await axios.get(url)
        this.listaHemeros = res.data
        // console.log(this.nombresTesisY)
      } catch (error) {
        alert(error)
      }
    },
    mostrarDatosHemero (idHemero) {
      this.getDatosHemero(idHemero)
      this.activaModo('Sel')
    },
    async getDatosHemero (idSelecc) {
      try {
        const url = `${this.URLbase}/hemerografias/getHemeroData`
        const hemeroId = { _id: idSelecc }
        const res = await axios.post(url, hemeroId)
        this.colVista = res.data
        this.autoresHemero = res.data.autores
      } catch (error) {
        alert(error)
      }
    },
    editar () {
      this.IsModoSalirEdi = !this.IsModoSalirEdi
      // Si es modo edición, hace copia de los datos actuales por si se cancela
      if (this.IsModoSalirEdi) {
        this.colVistaBkUp = JSON.parse(JSON.stringify(this.colVista))
        this.autoresHemeroBkUp = JSON.parse(JSON.stringify(this.autoresHemero))
        this.hemeroSelBkUp = this.hemeroSel
        this.activaModo('EDI')
      } else {
        // Si se cancela, resatura los valores previos
        this.colVista = JSON.parse(JSON.stringify(this.colVistaBkUp))
        this.autoresHemero = JSON.parse(JSON.stringify(this.autoresHemeroBkUp))
        this.hemeroSel = this.hemeroSelBkUp
        this.activaModo('Sel')
      }
    },
    cambioForm () {
      if (this.IsModoSalirMas && this.minDatos) {
        this.activaModo('MASs')
      }
      if (this.IsModoSalirEdi && this.minDatos) {
        this.activaModo('EDIs')
      }
    },
    async borrar () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de esta hemerografía. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C'
      )
      if (response === 'borrar') {
        try {
          const url = `${this.URLbase}/hemerografias/borrarHemero`
          const hemeroId = { _id: this.colVista._id }
          axios.post(url, hemeroId, {
            headers: {
              authorization: this.token
            }
          })
            .then(result => {
              switch (result.status) {
                case 200:
                  this.blanquearColVista()
                  this.alertJoa('¡Registro borrado con éxito!', 'S')
                  this.getListaHemeros()
                  break
                case 500:
                  this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
                  break
                default:
                  this.alertJoa('Algo salió mal, intenta otra vez', 'E')
              }
            })
            .catch(error => {
              console.log(error)
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
            })
        } catch (error) {
          alert(error)
        }
      }
    },

    async save () {
      // this.colVista.imgRecorte = this.imgRecorte
      this.colVista.autores = this.autoresHemero
      try {
        const url = `${this.URLbase}/hemerografias/save`
        const hemero = this.colVista
        await axios.post(url, hemero, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error al guardar, intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos guardados con éxito!', 'S')
                break
            }
            this.getListaHemeros()
            this.IsModoSalirMas = false
            this.IsModoSalirEdi = false
            this.blanquearColVista()
            this.activaModo('INI')
          })
      } catch (error) {
        alert(error)
      }
    },
    async getAutores () {
      try {
        const url = `${this.URLbase}/autores/listAutores`
        const res = await fetch(url)
        this.autores = await res.json()
      } catch (error) {
        alert(error)
      }
    },
    addAutor () {
      if (this.colVista.titulo) { this.modalAutores = true }
    },
    recargarAutores () {
      this.getAutores()
    },
    // Elimina el último autor asociado al libro
    delAutor () {
      this.autoresHemero.pop()
    },
    // Añade los autores en orden de un libro
    otroAutor (autorRecibido) {
      if (!this.autoresHemero.includes(autorRecibido)) { this.autoresHemero.push(autorRecibido) }
    },
    cerrarModal () {
      this.modalAutores = false
    },
    nuevo () {
      this.IsModoSalirMas = !this.IsModoSalirMas
      if (this.IsModoSalirMas) {
        this.colVistaBkUp = JSON.parse(JSON.stringify(this.colVista))
        this.autoresHemeroBkUp = JSON.parse(JSON.stringify(this.autoresHemero))
        this.hemeroSelBkUp = JSON.parse(JSON.stringify(this.hemeroSel))
        this.blanquearColVista()
        this.activaModo('MAS')
        // this.setFocus()
      } else {
        this.hemeroSel = this.hemeroSelBkUp
        if (this.hemeroSel.titulo) {
          this.colVista = JSON.parse(JSON.stringify(this.colVistaBkUp))
          this.autoresHemero = JSON.parse(JSON.stringify(this.autoresHemeroBkUp))
          this.activaModo('Sel')
        } else {
          this.blanquearColVista()
          this.activaModo('INI')
        }
      }
    },
    blanquearColVista () {
      this.colVista = {}
      this.autoresHemero = []
      this.hemeroSel = []
    },
    cargarPortada (event) {
      // Asignamos la imagen a nuestra data
      const portada = event.target.files[0]
      // Si imagen > 500kB alertamos y salimos
      const tamaño = portada.size
      if (tamaño > 500000) {
        alert('El tamaño del archivo es: ' +
        Math.round(tamaño / 1000) +
        'kb. Por favor, selecciona un archivo de un tamaño menor a 500 kb')
      } else {
        // Cargamos la previsualización
        const reader = new FileReader()
        reader.readAsDataURL(portada)
        reader.onload = e => { this.colVista.recorteImg = e.target.result }
      }
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0]
          break
        case 'Sel':
          this.confModo = [1, 1, 1, 0, 0]
          break
        case 'MAS':
          this.confModo = [1, 0, 0, 0, 1]
          break
        case 'MASs':
          this.confModo = [1, 0, 0, 1, 1]
          break
        case 'EDI':
          this.confModo = [0, 1, 0, 0, 1]
          break
        case 'EDIs':
          this.confModo = [0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    }
  },
  computed: {
    autoresVista () {
      return this.autoresHemero.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ')
    },
    minDatos () {
      return (!!this.colVista.titulo && !!this.colVista.publicacion)
    },
    ...mapState(['usuarioEnSesion'])
  },
  watch: {
    autoresVista () {
      if ((this.IsModoSalirEdi || this.IsModoSalirMas) && this.autoresHemero.length > 0) {
        this.cambioForm()
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
.imgRecorte{
  margin-top: 75px;
  width:80%;
  justify-self: center;
  box-shadow: rgb(53, 52, 52) 5px 5px 7px;
}
.imgRecorte2{
  display:none;
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 2%;
}
article.Form {
  padding-top: 20px;
}
.Btns {
  /* display: grid; */
  padding-left: 20px;
  padding-top: 20px;
  /* position: sticky; no funciona */
}
.formInd{
  margin-top: 55px;
}
.formIndTel{
  display:none;
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: var(--az-ico);
}
.check{
  display: flex;
  margin-top: 2%;
}
.check p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  padding-right: 4px;
  max-width: 150px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}
#titReg{
  font-weight: bold;
}
.BtnImg{
  display:flex;
  align-items: center;
}
.BtnImg p{
  color:black;
  font-size: 13px;
  padding-top: 4px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: relative;
  /* z-index: -1; *****/
  visibility:hidden;
}
/*Esta clase da el formato al boton y la etiqueta */
.inputfile + label {
  /* width: 63.5%;  */
  cursor: pointer;
  padding: 5px;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 6px;
  color: black;
  font-size: 16px;
}
.inputfile + label:hover {
  transform: scale(1.08);
  /* background-color: rgb(192, 205, 206); */
  /* .inputfile:focus + label, .inputfile.has-focus + label,*/
}
.inputfile:disabled + label {
  color: #8fa3ad;
}
.icon-icoSubirImg {
  color: var(--az-ico);
  font-size: 1.45em;
  padding-left: 9px;
  padding-right: 9px;
}
input[type=checkbox] {
  transform: scale(1.2);
}
@media screen and (max-width: 600px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  article.Form {
    padding-top: 10px;
    overflow: scroll;
  }
  .Blk-Campo {
    width:94%;
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
    margin-left:3%;
  }
  .Blk-Campo p{
    max-width: 80%;
  }
  .campo{
    width: 100%;
    margin: 0 0 0 0;
  }
  .check{
    width: 43%;
    justify-content: space-between;
    margin-top: 6px;
    /* border: solid 1px orange; */
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
  }
  .formInd{
    display: none;
  }
  .formIndTel{
    display: block;
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
    textarea.campo, input.campo, div.campo{
    width: 97%;
    margin-left:0%;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
  .imgRecorte2{
    display:inline-flex;
    width: 65%;
    margin-top: 5px;
    margin-bottom:15px;
    justify-self: center;
    box-shadow: rgb(53, 52, 52) 5px 5px 7px;
  }
}
</style>
